// File for logic corresponding to header component
import { Component } from 'js-component-framework';
import 'images/alleybot-logo.jpg';
import './header.scss';

/**
 * Component for site header
 */
export default class Header extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Other Options
    this.offset = this.options.offset;
    this.init();
  }

  init() {
    const {
      menu,
      mobileToggle,
      navFlyout,
      flyout,
    } = this.children;

    // If for some reason there is no navigation, bail.
    if (! menu || ! mobileToggle || ! navFlyout) {
      return;
    }

    const body = document.getElementsByTagName('body')[0];

    mobileToggle.addEventListener('click', () => {
      mobileToggle.classList.toggle('menu-open');
      body.classList.toggle('menu-open');
      menu.classList.toggle('open');
    });

    navFlyout.addEventListener('click', () => {
      navFlyout.classList.toggle('flyout-open');
      body.classList.toggle('flyout-open');
      flyout.classList.toggle('open');
    });
  }
}
